<template>

    <div>
        <b-form>

            <b-tabs v-model="activeTabIndex">
                <b-tab title="Info" active>

                    <template v-for="(value, field) in formData">

                        <template v-if="!hideFields(field)">

                            <b-form-group
                                    :key="field"
                                    :label="transformLabel(field)"
                                    :label-for="field"
                            >

                                <b-form-input
                                        :key="field"
                                        :id="field"
                                        v-validate="'required'"
                                        v-model="formData[field]"
                                        :disabled="loading"
                                        :data-vv-name="transformLabel(field)"
                                        :class="{'form-control':true, 'is-invalid':invalidValue(transformLabel(field))}"
                                        type="text"
                                />

                                <b-form-invalid-feedback
                                        :force-show="invalidValue(transformLabel(field))"
                                >
                                    {{ errors.first(transformLabel(field)) }}
                                </b-form-invalid-feedback>

                            </b-form-group>

                        </template>

                    </template>

                </b-tab>

                <b-tab title="Translations">

                    <TranslationForm
                            v-if="translations"
                            :translations="translations"
                            :new-translation-item="newTranslationConstructor"
                            ref="TranslationForm"
                            @validateForm="validateForm"
                    />

                </b-tab>

            </b-tabs>

        </b-form>

    </div>

</template>

<script>
    import arrayToObject from "@/libs/arrayToObject";
    import {removeSymbol} from "@/libs/backend/apimapper";
    import cloneObject from "@/libs/cloneObject";
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import TranslationForm from "@/components/Includes/TranslationForm/TranslationForm.vue";
    import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
    import Multiselect from 'vue-multiselect';

    export default {
        name: 'HoroscopeKeywordForm',
        components: {
            Multiselect,
            TranslationForm
        },
        props: {
            formData: {
                type: Object,
                required: false,
            },
            loading: {
                type: Boolean,
                required: false,
            },
        },
        data() {
            return {
                date: '',
                config: {
                    format: 'YYYY-MM-DD',
                    formatted: 'll',
                    // range: false,
                    onlyDate: true,
                    overlay: true,
                    dark: true
                },
                activeTabIndex: 0,
                newTranslationConstructor: {
                    locale: '',
                    title: ''
                },
                translations: [],
            }
        },
        watch: {
            formData() {
                this.getTranslationsData();
                this.defaultTab();
            }
        },
        methods: {
            invalidValue(fieldName) {
                return this.$validator.errors.has(fieldName);
            },

            transformData() {
                const horoscopeData = cloneObject(this.formData);
                horoscopeData.translations = arrayToObject(this.translations, 'locale');
                return horoscopeData;
            },

            validateForm() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('saveHoroscopeKeyword', this.transformData());
                    }
                });
            },

            handleSave() {
                this.$refs.TranslationForm.validateTranslations();
            },

            transformLabel(field) {
                return capitalizeFirstLetter(field);
            },

            hideFields(field) {
                return field === 'id' || field === 'translations';
            },

            getTranslationsData() {
                if (this.formData) {
                    const sourceData = Object.values(this.formData.translations);
                    sourceData.filter((attr) => removeSymbol(attr));
                    this.translations = sourceData;
                }
            },

            defaultTab() {
                this.activeTabIndex = 0;
            }
        }
    }
</script>
<style lang="scss">
    .form-group #deviceId {
        text-transform: uppercase;
    }
</style>